import { Checkbox } from '@ps-design-system/components/Checkbox';
import Account24 from '@ps-design-system/icons/Account/Account24';
import Messages24 from '@ps-design-system/icons/Messages/Messages24';
import Safe24 from '@ps-design-system/icons/Safe/Safe24';
import Signage24 from '@ps-design-system/icons/Signage/Signage24';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import SharedIntlProviderHOC from '../shared-components/hocs/sharedIntlProviderHOC';

const TrustAndSafetyWarning = ({ isAccepted, setIsAccepted }) => {
  const prefix = SharedIntlProviderHOC.getUrlPrefix();
  const urlPrefix = prefix ? `/${prefix}` : '';

  return (
    <div className="TrustAndSafetyWarning">
      <div className="ts-warning-checklist-wrap">
        <h5 className="ts-warning-title">
          <FormattedMessage
            id="inbox.trust_and_safety_warning.safety_space"
            defaultMessage="The safety of your space and guests is your responsibility."
          />
        </h5>

        <p className="margin-lg-bottom">
          <FormattedMessage
            id="inbox.trust_and_safety_warning.review_checklist"
            defaultMessage="Review the following checklist before accepting this booking."
          />
        </p>

        <div className="ts-warning-list">
          <div className="ts-warning-list-item">
            <div>
              <Messages24 />
            </div>

            <p className="no-bottom-margin">
              <FormattedMessage
                id="inbox.trust_and_safety_warning.evaluate_guest"
                defaultMessage="Thoroughly evaluate the guest and their proposed activity to determine if the booking is appropriate for your space."
              />
            </p>
          </div>

          <div className="ts-warning-list-item">
            <div>
              <Account24 />
            </div>

            <p className="no-bottom-margin">
              <FormattedMessage
                id="inbox.trust_and_safety_warning.make_sure"
                defaultMessage="Have someone on-site to supervise and monitor your space and amenities."
              />
            </p>
          </div>

          <div className="ts-warning-list-item">
            <div>
              <Safe24 />
            </div>

            <p className="no-bottom-margin">
              <FormattedMessage
                id="inbox.trust_and_safety_warning.remove_vulnerable"
                defaultMessage="Remove and/or secure vulnerable or sensitive items from your space."
              />
            </p>
          </div>

          <div className="ts-warning-list-item">
            <div>
              <Signage24 />
            </div>

            <p className="no-bottom-margin">
              <FormattedMessage
                id="inbox.trust_and_safety_warning.consistent_w_agreement"
                defaultMessage="Consistent with the {servicesAgreement}, guest insurance is required for this booking to proceed. Peerspace may require evidence of insurance from the guest. If requested and not provided, Peerspace will cancel the booking."
                values={{
                  servicesAgreement: (
                    <a
                      href={`https://www.peerspace.com${urlPrefix}/legal/terms/cancellation-policy`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FormattedMessage
                        id="inbox.trust_and_safety_warning.ps_services_agreement"
                        defaultMessage="Peerspace Services Agreement"
                      />
                    </a>
                  )
                }}
              />
            </p>
          </div>
        </div>
      </div>

      <div className="ts-warning-checkbox-wrap">
        <Checkbox
          checked={isAccepted}
          onCheckedChange={setIsAccepted}
          alignment="top"
          classNames={{
            mainWrapper: 'tw-items-start',
            description: 'tw-ml-16'
          }}
          description={
            <FormattedMessage
              id="inbox.trust_and_safety_warning.confirm_checklist"
              defaultMessage="By accepting this booking, I confirm my agreement to the {servicesAgreement}, which includes the {communityGuidelines} and {cancellationPolicy}, and acknowledge that Peerspace is not liable for any incidents resulting from the actions of your guest or an attendee."
              values={{
                servicesAgreement: (
                  <a
                    href={`https://www.peerspace.com${urlPrefix}/legal/terms`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FormattedMessage
                      id="inbox.trust_and_safety_warning_checkbox.ps_services_agreement"
                      defaultMessage="Peerspace Services Agreement"
                    />
                  </a>
                ),
                communityGuidelines: (
                  <a
                    href={`https://www.peerspace.com${urlPrefix}/legal/terms/community-guidelines`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FormattedMessage
                      id="inbox.trust_and_safety_warning_checkbox.community_guidelines"
                      defaultMessage="Community Guidelines"
                    />
                  </a>
                ),
                cancellationPolicy: (
                  <a
                    href={`https://www.peerspace.com${urlPrefix}/legal/terms/cancellation-policy`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FormattedMessage
                      id="inbox.trust_and_safety_warning_checkbox.cancellation_policy"
                      defaultMessage="Cancellation and Refund Policy"
                    />
                  </a>
                )
              }}
            />
          }
        />
      </div>
    </div>
  );
};

TrustAndSafetyWarning.propTypes = {
  isAccepted: PropTypes.bool.isRequired,
  setIsAccepted: PropTypes.func.isRequired
};

export default TrustAndSafetyWarning;
